import { Button, TableItem, TableMessage } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { Table } from 'components/organisms';
import { useFormikContext } from 'formik';
import { useNewWindowNavigate } from 'hooks/useNewWindowNavigate';
import { t } from 'i18next';
import { PiNavigationArrow, PiPlus, PiTrash } from 'react-icons/pi';
import { IClientAccountForm } from 'services/client-account/types';
import { useGetMerchLightList } from 'services/merch/light';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const ClientAccountMerch = () => {
  const merchLightList = useGetMerchLightList();

  const { values, setFieldValue, status, initialStatus } =
    useFormikContext<IClientAccountForm>();

  const navigateToNewWindow = useNewWindowNavigate();

  const merchOptions = (merchList: string[]) =>
    merchLightList.data
      ?.filter(merch => !merchList.includes(merch.id))
      .map(merch => ({
        label: merch.name,
        value: merch.id,
      })) ?? [];

  const goToTrack = (id: string) => {
    navigateToNewWindow(`merch/${id}`);
  };

  return (
    <Table
      displayMode
      data={{
        nodes:
          values.merch?.map((merch, key) => ({
            id: key,
            value: merch.id,
            label: merch.name,
          })) ?? [],
      }}
      columns={[
        {
          label: t('input.label.merch'),
          renderCell: ({ label, value, id }) => (
            <TableItem>
              {status?.displayMode ? (
                <TableItem.Text text={label} />
              ) : (
                <FormInput.Select
                  name={`merch[${id}].id`}
                  label={t('input.label.merch')}
                  options={merchOptions(values.merch?.map(merch => merch.id))}
                  onChange={option => {
                    setFieldValue(`merch[${id}].id`, option.value);
                    setFieldValue(`merch[${id}].name`, option.label);
                  }}
                  value={{ label: label ?? '-', value: value }}
                />
              )}
            </TableItem>
          ),
        },

        {
          label: '',
          renderCell: ({ value }) => (
            <TableItem justifyPosition='end'>
              {status?.displayMode ? (
                <Button isClear onlyIcon onClick={() => goToTrack(value)}>
                  <Button.Icon
                    icon={<PiNavigationArrow transform='scale(-1,1)' />}
                  />
                </Button>
              ) : (
                <Button
                  variant={BUTTON_VARIANT.remove}
                  isClear
                  onlyIcon
                  onClick={() =>
                    setFieldValue(
                      `merch`,
                      values.merch?.filter(merch => merch.id !== value)
                    )
                  }>
                  <Button.Icon icon={<PiTrash />} />
                </Button>
              )}
            </TableItem>
          ),
        },
      ]}
      tableOptions={
        status?.displayMode
          ? undefined
          : {
              renderAfterTable: () => (
                <tfoot className='full-width-footer'>
                  <TableMessage
                    className='cursor-pointer'
                    disable={
                      values.merch?.length
                        ? !values.merch[values.merch.length - 1]?.id.length
                        : false
                    }
                    onClick={() =>
                      setFieldValue(`merch[${values.merch?.length ?? 0}]`, {
                        id: '',
                        name: '',
                      })
                    }>
                    <TableItem.Text text={t('button.add')} />
                    <PiPlus />
                  </TableMessage>
                </tfoot>
              ),
            }
      }
      size='compact'
    />
  );
};

export default ClientAccountMerch;
